// HSL color type

export type HSLColor = {
  alpha: number // alpha (0-1)
  hue: number // hue (0-1)
  lightness: number // lightness (0-1)
  saturation: number // saturation (0-1)
}
